import { Component } from '@angular/core';
import { PeptideTherapyComponent } from '@consultation-upsells/peptide-therapy/peptide-therapy.component';
import { QuestionnaireAnswers } from '@enums/questionnaire-answers';
import { UpsellSlugs } from '@enums/upsell-slugs';
import { SelectableOption } from '@models/selectable-option';

@Component({
  selector: 'app-peptide-therapy-trt',
  imports: [PeptideTherapyComponent],
  templateUrl: './peptide-therapy-trt.component.html',
})
export class PeptideTherapyTrtComponent {
  public readonly options: SelectableOption[] = [
    new SelectableOption(
      'Add BPC-157 - Reduces inflammation and accelerates tissue repair for better daily performance.',
      UpsellSlugs.PeptideBPC157,
    ),
    new SelectableOption(
      'Add CJC-1295/Ipamorelin - Supports recovery, energy, sleep, and metabolic health.',
      UpsellSlugs.PeptideCJC1295Ipamorelin,
    ),
    new SelectableOption(
      'Add GHK-Cu - Enhances circulation, cellular repair, skin quality, and full-body vitality.',
      UpsellSlugs.PeptideGHKCu,
    ),
    new SelectableOption("No, I don't want to try Peptide Therapy at this time.", QuestionnaireAnswers.No),
  ];
}
